import { Theme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/styles";
import { colours } from "../../styles/colours";

const tabsStyles = () => ({
  root: {
    width: "100%",
    boxShadow: `inset 0 -1px 0 0 ${colours.lighterBlue}`,
  },
  indicator: {
    backgroundColor: colours.blue,
  },
});

const tabItemStyles = ({ breakpoints }: Pick<Theme, "breakpoints">) => ({
  root: {
    minHeight: 53,
    minWidth: 80,
    [breakpoints.up("md")]: {
      minWidth: 120,
    },
    "&:hover": {
      backgroundColor: "rgba(29, 161, 242, 0.1)",
      "& $wrapper": {
        color: colours.blue,
      },
    },
    "&$selected": {
      "& *": {
        color: colours.blue,
      },
    },
  },
  selected: {},
  textColorInherit: {
    opacity: 1,
  },
  wrapper: {
    textTransform: "none",
    fontSize: 15,
    fontWeight: 700,
    color: colours.darkBlueGrey,
  },
});

export const tabsStylesHook = {
  useTabs: makeStyles(tabsStyles),
  useTabItem: makeStyles(createStyles(tabItemStyles)),
};
